<template>
    <!-- Meta Tags -->
    <Head title="Tu año en un minuto" />

    <div data-slide="slide" class="slide" >
        <div class="slide-items">

            <!-- History 1-->
            <div class="history w-screen bg-yellow" :class="{ active: activeIndex === 0 }">
                <div class="h-screen pt-16 flex flex-col justify-center items-center">
                    <div class="container flex flex-col justify-center items-center gap-4">
                        <img class="w-44 mx-auto" :src="`${$page.props.baseUrl}/images/2024.svg`" alt="2024" ref="h1Age" />
                        <h1 class="text-center text-5xl text-red" ref="h1Title1">
                            REVIVAMOS TU AÑO
                            <br>
                            EN UN MINUTO
                        </h1>
                        <div>
                            <p class="font-circular font-bold text-gray text-xl text-center" ref="h1Title2">
                                "{{ client.name }}"
                            </p>
                            <p class="font-circular font-book text-gray text-xl text-center h-20" ref="h1Text">
                            </p>
                        </div>
                        <button @click="next()" class="font-circular bg-red rounded-full text-xl px-4 py-2" ref="h1Button">Veamos tus logros</button>
                    </div>
                    <div class="relative w-full h-48">
                        <img class="absolute top-0 -left-[8rem]" :src="`${$page.props.baseUrl}/images/history1/pink_hand.svg`" alt="Pink Hand" ref="h1HandPink"/>
                        <img class="absolute top-12 -right-[8rem]" :src="`${$page.props.baseUrl}/images/history1/white_hand.svg`" alt="White Hand" ref="h1HandWhite" />
                    </div>
                </div>
            </div>

            <!-- History 2-->
            <div class="history w-screen bg-blue" :class="{ active: activeIndex === 1 }">
                <div class="h-screenfooter pt-16 flex flex-col justify-between items-center gap-2">
                    <div class="container flex flex-col justify-center items-center gap-4">
                        <div class="font-circular font-medium rounded-full border border-white px-4 py-1 text-xs">
                            RESUMEN DE VENTAS
                        </div>
                        <h1 class="text-center text-6xl text-white" ref="h2Title">
                            wow! vendiste <span class="text-yellow font-bold">{{ numberWithCommas(client.total_pieces) }}</span> piezas
                        </h1>
                        <p class="font-circular font-book text-white text-xl text-center leading-5 h-20">
                            <span ref="h2Text"> </span>
                            <span class='text-yellow' ref="h2Text2"> {{ Math.round((parseInt(client.total_pieces)*0.15)/3) }} pisos</span>
                        </p>
                    </div>
                    <div class="relative w-full">
                        <img class="w-52 mx-auto" :src="`${$page.props.baseUrl}/images/history2/building.png`" alt="Edificio" ref="h2Building"/>

                        <img class="absolute top-0 left-20 w-10" :src="`${$page.props.baseUrl}/images/history2/red_ice.png`" alt="Producto" ref="h2Product1"/>
                        <img class="absolute top-[3rem] left-5 w-10" :src="`${$page.props.baseUrl}/images/history2/magnum_almendras.png`" alt="Producto" ref="h2Product2" />
                        <img class="absolute top-[6rem] left-14 w-16" :src="`${$page.props.baseUrl}/images/history2/cornetto.png`" alt="Producto" ref="h2Product3" />
                        <img class="absolute top-[12rem] left-5 w-8" :src="`${$page.props.baseUrl}/images/history2/yellow_ice.png`" alt="Producto" ref="h2Product4" />
                        <img class="absolute top-[1rem] right-20 w-14" :src="`${$page.props.baseUrl}/images/history2/mordisko.png`" alt="Producto" ref="h2Product5" />
                        <img class="absolute top-[3rem] right-5 w-12" :src="`${$page.props.baseUrl}/images/history2/pink_ice.png`" alt="Producto" ref="h2Product6" />
                        <img class="absolute top-[8rem] right-16 w-16" :src="`${$page.props.baseUrl}/images/history2/star_ice.png`" alt="Producto" ref="h2Product7" />
                        <img class="absolute top-[12rem] right-4 w-10" :src="`${$page.props.baseUrl}/images/history2/magnum.png`" alt="Producto" ref="h2Product8" />
                    </div>
                </div>
                <div class="relative w-full h-16 bg-blue2 font-circular flex justify-center items-center">
                    <div class="rounded-full w-8 h-8 flex justify-center items-center bg-white">
                        <img class="w-6" :src="`${$page.props.baseUrl}/images/share.svg`" alt="Compartir" />
                    </div>
                    <strong class="text-lg ml-2">Compartir</strong>
                </div>
            </div>

            <!-- History 3-->
            <div class="history w-screen bg-green" :class="{ active: activeIndex === 2 }">
                <div class="h-screenfooter pt-16 flex flex-col justify-between items-center gap-2">
                    <div class="container h-full flex flex-col justify-center items-center gap-2">
                        <div class="font-circular font-medium rounded-full border border-white px-4 py-1 text-xs">
                            RESUMEN DE VENTAS
                        </div>
                        <div class="text-center text-5xl text-white">
                            <div ref="h3Title1">tus clientes tienen</div>
                            <div class="text-yellow text-6xl" ref="h3Title2">3 favoritos</div>
                        </div>
                        <div class="w-full h-[16rem] mx-auto flex justify-center items-end gap-6">
                            <div class="flex flex-col justify-end items-center">
                                <div class="relative w-12 rounded-full bg-yellow h-48" ref="h3Bar1">
                                    <img class="absolute -top-4 w-full transform scale-150"
                                    :src="`${$page.props.baseUrl}/images/products/${client.product1}.png`" alt="Producto" ref="h3Product1"/>
                                </div>
                                <div class="text-center font-circular text-sm" ref="h3ProductName1">
                                    {{ client.product1 }}
                                </div>
                            </div>
                            <div class="flex flex-col justify-end items-center">
                                <div class="relative w-12 rounded-full bg-orange h-36" ref="h3Bar2">
                                    <img class="absolute -top-4 w-full transform scale-150"
                                    :src="`${$page.props.baseUrl}/images/products/${client.product2}.png`" alt="Producto" ref="h3Product2"/>
                                </div>
                                <div class="text-center font-circular text-sm" ref="h3ProductName2">
                                    {{ client.product2 }}
                                </div>
                            </div>
                            <div class="flex flex-col justify-end items-center">
                                <div class="relative w-12 rounded-full bg-pink h-28" ref="h3Bar3">
                                    <img class="absolute -top-4 w-full transform scale-150"
                                    :src="`${$page.props.baseUrl}/images/products/${client.product3}.png`" alt="Producto" ref="h3Product3"/>
                                </div>
                                <div class="text-center font-circular text-sm" ref="h3ProductName3">
                                    {{ client.product3 }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="bg-green2 w-full font-circular font-book text-center py-4 px-4 leading-5">
                        Refrescaste a tus clientes de una
                        <br>
                        <span class="text-yellow">manera deliciosa</span>
                    </div>
                </div>
                <div class="relative w-full h-16 bg-green3 font-circular flex justify-center items-center">
                    <div class="rounded-full w-8 h-8 flex justify-center items-center bg-white">
                        <img class="w-6" :src="`${$page.props.baseUrl}/images/share.svg`" alt="Compartir" />
                    </div>
                    <strong class="text-lg ml-2">Compartir</strong>
                </div>
            </div>

            <!-- History 4-->
            <div class="history w-screen bg-pink" :class="{ active: activeIndex === 3 }">
                <div class="h-screenfooter pt-16 flex flex-col justify-between items-center gap-2">
                    <div class="container h-full flex flex-col justify-center items-center gap-4">
                        <div class="font-circular font-medium rounded-full border border-white px-4 py-1 text-xs">
                            AHORRO CON PROMOS
                        </div>
                        <p class="font-circular text-lg leading-6" ref="h4Text1">
                            Ahorraste en total:
                        </p>
                        <div class="text-6xl -mt-4" ref="h4Title">
                            $<span class="text-yellow text-8xl">{{ numberWithCommas(client.total_savings) }}</span>MXN
                        </div>
                        <div class="font-circular text-lg leading-6 text-center">
                            <span ref="h4Text2"></span>
                            <br>
                            <span class="text-yellow font-bold" ref="h4Title2">
                                {{ Math.round(parseInt(client.total_savings)/35) }}
                                Magnum® Almendras
                            </span>
                        </div>
                        <div class="grid grid-cols-20 items-start" ref="h4Products"></div>
                    </div>
                    <div class="bg-pink2 w-full font-circular font-book text-center py-4 px-4 leading-5">
                        Con todas las promos, pudiste haber ahorrado <span class="text-yellow">${{ numberWithCommas(client.total_savings_promotions) }}</span>, aunque es mejor dejar el pasado y <strong>prepararse para el 2025</strong>
                    </div>
                </div>
                <div class="relative w-full h-16 bg-pink3 font-circular flex justify-center items-center">
                    <div class="rounded-full w-8 h-8 flex justify-center items-center bg-white">
                        <img class="w-6" :src="`${$page.props.baseUrl}/images/share.svg`" alt="Compartir" />
                    </div>
                    <strong class="text-lg ml-2">Compartir</strong>
                </div>
            </div>

            <!-- History 5-->
            <div class="history w-screen bg-orange" :class="{ active: activeIndex === 4 }">
                <div class="h-screenfooter pt-16 flex flex-col justify-between items-center gap-2">
                    <div class="container h-full flex flex-col justify-center items-center gap-2">
                        <div class="font-circular font-medium rounded-full border border-white px-4 py-1 text-xs">
                            GANANCIAS
                        </div>
                        <p class="font-circular text-lg" ref="h5Text1">
                            En total, ganaste:
                        </p>
                        <div class="text-6xl -mt-2" ref="h5Title">
                            $<span class="text-yellow text-7xl">{{ numberWithCommas(client.total_gain) }}</span>MXN
                        </div>
                        <p class="font-circular leading-6 text-lg text-center" ref="h5Text2">
                        </p>
                        <div class="flex justify-center items-end -mt-2" ref="h5Data">
                            <div class="w-32 flex flex-col justify-center items-center text-center">
                                <img class="w-28" :src="`${$page.props.baseUrl}/images/history5/chips.png`" alt="Chips" ref="h5Chips"/>
                                <p class="text-yellow text-5xl mb-2">{{ numberWithCommas(Math.round(parseInt(client.total_gain)/3)) }}</p>
                                <p class="text-xl leading-5">papitas o <br>galletas</p>
                            </div>
                            <div class="text-2xl leading-5 mb-16">ó</div>
                            <div class="w-32 flex flex-col justify-center items-center text-center">
                                <img class="w-20" :src="`${$page.props.baseUrl}/images/history5/soda.png`" alt="Soda" ref="h5Soda"/>
                                <p class="text-yellow text-5xl mb-2">{{ numberWithCommas(Math.round(parseInt(client.total_gain)/2)) }}</p>
                                <p class="text-xl leading-5">refrescos <br>de cola</p>
                            </div>
                        </div>
                    </div>
                    <div class="bg-orange2 w-full font-circular font-book text-center py-6 px-4 leading-5">
                        Tener a <strong>Helados Holanda®</strong> en tu tiendita, ¡sí hace la diferencia!
                    </div>
                </div>
                <div class="relative w-full h-16 bg-orange3 font-circular flex justify-center items-center">
                    <div class="rounded-full w-8 h-8 flex justify-center items-center bg-white">
                        <img class="w-6" :src="`${$page.props.baseUrl}/images/share.svg`" alt="Compartir" />
                    </div>
                    <strong class="text-lg ml-2">Compartir</strong>
                </div>
            </div>

            <!-- History 6-->
            <div class="history w-screen bg-yellow" :class="{ active: activeIndex === 5 }">
                <div class="h-screen pt-16 flex flex-col justify-center items-center">
                    <div class="container max-w-md mx-auto flex flex-col justify-center items-center gap-4">
                        <h1 class="text-center text-5xl text-red">
                            Este fue tu 2024 con
                            helados holanda<sup>®</sup>
                        </h1>
                        <p class="font-circular font-book text-gray text-xl text-center">
                            ¿Cómo fue tu experiencia este año con nosotros?
                        </p>
                        <form @submit.prevent="sendAnswer()" class="flex flex-col justify-center items-center">
                            <div class="w-full">
                                <p class="font-circular font-bold text-gray text-2xl text-center">Califícanos:</p>
                                <div class="w-full flex justify-center items-center gap-1 my-4">
                                    <div @click="qualification_face = 1" class="w-14 h-14 rounded-full border-2 border-transparent hover:border-red hover:bg-red" :class="qualification_face == 1 ? 'border-red bg-red' : ''">
                                        <img class="w-14 object-cover" :src="`${$page.props.baseUrl}/images/history6/face1.png`" alt="Calificación" />
                                    </div>
                                    <div @click="qualification_face = 2" class="w-14 h-14 rounded-full border-2 border-transparent hover:border-red hover:bg-red" :class="qualification_face == 2 ? 'border-red bg-red' : ''">
                                        <img class="w-14 object-cover" :src="`${$page.props.baseUrl}/images/history6/face2.png`" alt="Calificación" />
                                    </div>
                                    <div @click="qualification_face = 3" class="w-14 h-14 rounded-full border-2 border-transparent hover:border-red hover:bg-red" :class="qualification_face == 3 ? 'border-red bg-red' : ''">
                                        <img class="w-14 object-cover" :src="`${$page.props.baseUrl}/images/history6/face3.png`" alt="Calificación" />
                                    </div>
                                    <div @click="qualification_face = 4" class="w-14 h-14 rounded-full border-2 border-transparent hover:border-red hover:bg-red" :class="qualification_face == 4 ? 'border-red bg-red' : ''">
                                        <img class="w-14 object-cover" :src="`${$page.props.baseUrl}/images/history6/face4.png`" alt="Calificación" />
                                    </div>
                                    <div @click="qualification_face = 5" class="w-14 h-14 rounded-full border-2 border-transparent hover:border-red hover:bg-red" :class="qualification_face == 5 ? 'border-red bg-red' : ''">
                                        <img class="w-14 object-cover" :src="`${$page.props.baseUrl}/images/history6/face5.png`" alt="Calificación" />
                                    </div>
                                </div>
                                <textarea v-model="text_improve" class="font-circular p-2 rounded-xl bg-white w-full text-gray" placeholder="Escribe aquí cómo podemos mejorar." required></textarea>
                            </div>
                            <button type="submit" class="font-circular bg-red rounded-full text-2xl px-6 py-3">Enviar</button>
                        </form>
                    </div>
                    <div class="relative w-full h-48 -mt-4">
                        <img class="absolute top-0 -left-[8rem]" :src="`${$page.props.baseUrl}/images/history1/pink_hand.svg`" alt="Pink Hand"/>
                        <img class="absolute top-12 -right-[8rem]" :src="`${$page.props.baseUrl}/images/history1/white_hand.svg`" alt="White Hand"/>
                    </div>
                </div>
            </div>

            <!-- History 7-->
            <div class="history w-screen bg-yellow" :class="{ active: activeIndex === 6 }">
                <div class="h-screen pt-16 flex flex-col justify-center items-center gap-2">
                    <div class="container flex flex-col justify-center items-center gap-4">
                        <h1 class="text-center text-4xl text-red">
                            Gracias por ser
                            <br>
                            parte de la familia de
                            <br>
                            Helados Holanda<sup>®</sup>
                        </h1>
                        <img class="w-60" :src="`${$page.props.baseUrl}/images/logo_holanda.png`" alt="Logo Holanda" />
                        <p class="text-black text-3xl font-circular text-center">
                            ¡Seguiremos mejorando para ti en <strong>2025</strong>!
                        </p>
                        <button @click="reset()" class="font-circular bg-red rounded-full text-xl px-4 py-2">Volver a ver</button>
                    </div>
                </div>
            </div>

        </div>
        <nav class="slide-nav" :class="controls ? 'h-full' : 'h-20'">
            <div class="slide-thumb flex flex-col">
                <div class="slide-thumb-content flex">
                    <span v-for="(item, index) in totalHistories" :key="index" @click="activeSlide(index)"
                          :class="{ active: activeIndex === index && play === true, pause: activeIndex === index && play === false }"
                    ></span>
                </div>
                <div class="flex justify-between items-center mt-2 px-4">
                    <div class="flex justify-start items-center gap-4">
                        <img class="w-10" :src="`${$page.props.baseUrl}/images/logo_holanda.png`" alt="Logo Holanda" />
                        <p class="text-xl">tu año en un minuto</p>
                    </div>
                    <div class="rounded-full" :class="play ? '' : 'bg-red'" @click="pause()">
                        <img class="w-8" :src="`${$page.props.baseUrl}/images/icon_pause.png`" alt="Icono Pausa" />
                    </div>
                </div>
            </div>
            <button v-if="controls" class="slide-prev" @click="prev"></button>
            <button v-if="controls" class="slide-next" @click="next"></button>
            <div v-if="shared" class="absolute left-0 bottom-0 w-full h-16" v-on:click="shareFb"></div>
        </nav>
    </div>


</template>

<script>
import axios from 'axios';
import { gsap } from "gsap";

import { TextPlugin } from "gsap/TextPlugin";

/* The following plugins are Club GSAP perks */
import { ScrambleTextPlugin } from "gsap/ScrambleTextPlugin";
import { SplitText } from "gsap/SplitText";


gsap.registerPlugin(TextPlugin,ScrambleTextPlugin,SplitText);

export default {
    name: 'Home',
    props: {
        client: Object
    },
    components: {
    },
    setup() {
        return {
        };
    },
    data(){
        return {
            activeIndex: 0,
            interval: null,
            totalHistories: 0,
            timer: 15000,
            history1Executed: false,
            history2Executed: false,
            history3Executed: false,
            history4Executed: false,
            history5Executed: false,
            play: true,
            controls: false,
            question: false,
            shared: false,
            qualification_face: null,
            text_improve: null,
        };
    },
    mounted() {
        this.totalHistories = document.querySelectorAll('.history').length;
        this.showHistory1()
        this.autoSlide();
    },
    beforeUnmount() {
        clearInterval(this.interval);
    },
    methods: {
        showHistory1(){
            if(this.history1Executed === true){
                return false;
            }
            let tl = gsap.timeline()
            tl.from(this.$refs.h1HandPink, {
                left:"-100vw",
                duration: 1
            });
            tl.from(this.$refs.h1HandWhite, {
                right:"-100vw",
                duration: 1
            }, "<");
            tl.from(this.$refs.h1HandPink, {
                y:"+=40", yoyo:true, repeat:4
            });
            tl.from(this.$refs.h1HandWhite, {
                y:"-=40", yoyo:true, repeat:4
            }, "<");

            tl.from(this.$refs.h1Age, {
                scale: 0,
                ease: "bounce.out",
                duration: 1
            });
            tl.from(this.$refs.h1Title1, {
                opacity: 0,
                duration: 1
            });
            tl.from(this.$refs.h1Title2, {
                opacity: 0,
                duration: 1
            });
            tl.fromTo(this.$refs.h1Text, {
                text: ""
            },{
                duration: 2,
                text: "Fueron 365 días llenos de sabor en los que brindaste muchas sonrisas :)"
            });
            tl.from(this.$refs.h1Button, {
                opacity: 0,
                duration: 1
            });

            this.history1Executed = true;
        },
        showHistory2(){
            if(this.history2Executed === true){
                return false;
            }

            let tl2 = gsap.timeline()

            tl2.from(this.$refs.h2Title, {
                scale: 0,
                duration: 1
            });
            tl2.fromTo(this.$refs.h2Text, {
                text: ""
            },{
                duration: 3,
                text: "Si apilamos una sobre otra, formarían un gran edificio frío de "
            });
            tl2.from(this.$refs.h2Text2, {
                opacity: 0,
                duration: 1
            });
            tl2.from(this.$refs.h2Building, {
                scale: 0,
                duration: 1
            });

            // Productos
            tl2.from(this.$refs.h2Product1, {
                scale: 0,
                ease: "bounce.out",
                duration: 0.5
            });
            tl2.from(this.$refs.h2Product8, {
                scale: 8,
                opacity: 0,
                ease: "bounce.out",
                duration: 0.5
            }, "<");

            tl2.from(this.$refs.h2Product2, {
                scale: 8,
                opacity: 0,
                ease: "bounce.out",
                duration: 0.5
            });
            tl2.from(this.$refs.h2Product5, {
                scale: 0,
                ease: "bounce.out",
                duration: 0.5
            }, "<");

            tl2.from(this.$refs.h2Product3, {
                scale: 0,
                ease: "bounce.out",
                duration: 0.5
            });
            tl2.from(this.$refs.h2Product6, {
                scale: 8,
                opacity: 0,
                ease: "bounce.out",
                duration: 0.5
            }, "<");

            tl2.from(this.$refs.h2Product4, {
                scale: 8,
                opacity: 0,
                ease: "bounce.out",
                duration: 0.5
            });
            tl2.from(this.$refs.h2Product7, {
                scale: 0,
                ease: "bounce.out",
                duration: 0.5
            }, "<");


            this.history2Executed = true;
        },
        showHistory3(){
            if(this.history3Executed === true){
                return false;
            }
            let tl3 = gsap.timeline()

            tl3.from(this.$refs.h3Title1, {
                scale: 0,
                duration: 1
            });
            tl3.from(this.$refs.h3Title2, {
                scale: 0,
                duration: 1
            });
            tl3.from(this.$refs.h3Bar1, {
                height: "0px",
                duration: 1
            });
            tl3.from(this.$refs.h3Product1, {
                scale: 0,
                duration: 1
            }, "<");
            tl3.from(this.$refs.h3ProductName1, {
                opacity: 0,
                duration: 1
            }, "<");

            tl3.from(this.$refs.h3Bar2, {
                height: "0px",
                duration: 1
            });
            tl3.from(this.$refs.h3Product2, {
                scale: 0,
                duration: 1
            }, "<");
            tl3.from(this.$refs.h3ProductName2, {
                opacity: 0,
                duration: 1
            }, "<");

            tl3.from(this.$refs.h3Bar3, {
                height: "0px",
                duration: 1
            });
            tl3.from(this.$refs.h3Product3, {
                scale: 0,
                duration: 1
            }, "<");
            tl3.from(this.$refs.h3ProductName3, {
                opacity: 0,
                duration: 1
            }, "<");

            this.history3Executed = true;
        },
        showHistory4(){
            if(this.history4Executed === true){
                return false;
            }
            let tl4 = gsap.timeline()


            tl4.from(this.$refs.h4Text1, {
                opacity: 0,
                duration: 1
            });
            tl4.from(this.$refs.h4Title, {
                opacity: 0,
                duration: 1
            });
            tl4.fromTo(this.$refs.h4Text2, {
                text: ""
            },{
                duration: 2,
                text: "Nada mal, podrías consentir a tu familia con"
            });
            tl4.from(this.$refs.h4Title2, {
                opacity: 0,
                duration: 1
            });
            tl4.fromTo(this.$refs.h4Products, {
                text: ""
            },{
                duration: 3,
                text: "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />" +
                    "<img class='w-4' src='images/history4/magnum_almendras_thumb.png' alt='product' />"
            });
            this.history4Executed = true;
        },
        showHistory5(){
            if(this.history5Executed === true){
                return false;
            }
            let tl5 = gsap.timeline()

            tl5.from(this.$refs.h5Text1, {
                opacity: 0,
                duration: 1
            });
            tl5.from(this.$refs.h5Title, {
                opacity: 0,
                duration: 1
            });
            tl5.fromTo(this.$refs.h5Text2, {
                text: ""
            },{
                duration: 2,
                text: "Para lograr esta cifra, hubieras tenido que vender"
            });
            tl5.from(this.$refs.h5Data, {
                opacity: 0,
                duration: 1
            });
            tl5.from(this.$refs.h5Chips, {
                rotation: 10,
                yoyo:true,
                repeat: -1
            });
            tl5.from(this.$refs.h5Soda, {
                rotation: -10,
                yoyo:true,
                repeat: -1
            }, "<");

            this.history5Executed = true;
        },
        runAnimation() {
            switch (this.activeIndex) {
                case 0:
                    this.controls = false;
                    this.showHistory1();
                    break;
                case 1:
                    this.controls = true;
                    this.showHistory2();
                    this.shared = true
                    break;
                case 2:
                    this.controls = true;
                    this.showHistory3();
                    this.shared = true
                    break;
                case 3:
                    this.controls = true;
                    this.showHistory4();
                    this.shared = true
                    break;
                case 4:
                    this.controls = true;
                    this.showHistory5();
                    this.shared = true
                    break;
                case 5:
                    this.shared = false
                    if(this.question || this.client.qualification_face){
                        this.next()
                    }else{
                        this.controls = false;
                        clearInterval(this.interval);
                    }
                    break;
                case 6:
                    this.shared = false
                    this.controls = false;
                    clearInterval(this.interval);
                    break;
                default:
                    break;
            }
        },
        activeSlide(index) {
            this.activeIndex = index;
        },
        prev() {
            this.activeIndex = this.activeIndex > 0 ? this.activeIndex - 1 : 1;
            if (this.play){
                this.autoSlide()
            }
            this.runAnimation()
        },
        next() {
            this.activeIndex = this.activeIndex < this.totalHistories - 1 ? this.activeIndex + 1 : 0;
            if (this.play){
                this.autoSlide()
            }
            this.runAnimation()
        },
        autoSlide() {
            clearInterval(this.interval);
            this.interval = setInterval(this.next, this.timer);
        },
        pause() {
            this.play = !this.play
            if (this.play){
                this.autoSlide();
            }else{
                clearInterval(this.interval);
            }
        },
        reset(){
            this.activeIndex = 0
            this.showHistory1()
            this.autoSlide();
            this.controls = true;
        },
        shareFb(){
            FB.init({
                appId            : '1314533069676279',
                autoLogAppEvents : true,
                xfbml            : true,
                version          : 'v11.0'
            });

            FB.ui({
                method: 'share',
                quote: "Mira mi 2024 con Holanda",
                hashtag: "#Mi2024ConHolanda",
                href: this.$page.props.currentUrl,
            }, function(response){});
        },
        numberWithCommas(x) {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
        sendAnswer() {
            const formData = new FormData();
            formData.append('client_id', this.client.id);
            formData.append('qualification_face', this.qualification_face);
            formData.append('text_improve', this.text_improve);

            axios.post(`/question/${this.client.id}`, formData)
                .then(response => {
                    this.question = true
                    this.next()
                })
                .catch(error => {
                    console.error(error);
                    this.errorMessage = error.response.data.message;
                });
        },
    }
};
</script>
<style>
.slide {
    @apply w-full grid;
}

.slide-items {
    @apply relative overflow-hidden;
    grid-area: 1/1;
}

.slide-nav {
    @apply grid;
    grid-area: 1/1;
    z-index: 1;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto 1fr;
}

.slide-nav button {
    -webkit-appearance: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    opacity: 1;
}

.slide-items > * {
    position: absolute;
    top: 0px;
    opacity: 0;
    pointer-events: none;
}

.slide-items > .active {
    position: relative;
    opacity: 1;
    pointer-events: initial;
}

.slide-thumb {
    @apply h-20 pt-2;
    display: flex;
    grid-column: 1 / 3;
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.00) 0%, rgba(0, 0, 0, 0.42) 100%);
}

.slide-thumb-content > span {
    flex: 1;
    display: block;
    height: 3px;
    background: rgba(255, 255, 255, 0.4);
    margin: 5px;
    border-radius: 3px;
    overflow: hidden;
}

.slide-thumb-content > span.active::after {
    content: '';
    display: block;
    height: inherit;
    background: rgba(255, 255, 255, 1);
    border-radius: 3px;
    transform: translateX(-100%);
    animation: thumb 15s forwards linear;
}

.slide-thumb-content > span.pause::after {
    content: '';
    display: block;
    height: inherit;
    background-color: rgba(255, 255, 255, 1);
    border-radius: 3px;
    transform: translateX(-50%);
}

@keyframes thumb {
    to {
        transform: initial;
    }
}

</style>
